import axios from 'axios'
import {
  getPropertyRequest,
  getPropertySuccess,
  getPropertyFail,
  updatePropertyStatusRequest,
  updatePropertyStatusSuccess,
  updatePropertyStatusFail,
  patchPropertyRequest,
  patchPropertySuccess,
  patchPropertyFail,
} from '../../../state/redux/slices/propertySlice.js'

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  timeout: 30000,
})

export const getProperty = propertyId => async dispatch => {
  try {
    dispatch(getPropertyRequest())
    const token = localStorage.getItem('authToken')
    const response = await api.get(`/v1/properties/${propertyId}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })
    dispatch(getPropertySuccess(response.data.properties))
  } catch (error) {
    dispatch(getPropertyFail(error.response?.data?.message || error.message))
  }
}

export const createProperty = propertyData => {
  const token = localStorage.getItem('authToken')
  return api.post('/v1/properties', propertyData, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  })
}

export const patchProperty = (propertyId, updatedData) => async dispatch => {
  try {
    dispatch(patchPropertyRequest())
    const token = localStorage.getItem('authToken')

    const response = await api.patch(`/v1/properties/update/${propertyId}`, updatedData, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })

    const updatedProperty = response.data.property
    dispatch(patchPropertySuccess(response.data.property))
    return updatedProperty
  } catch (error) {
    dispatch(patchPropertyFail(error.response?.data?.message || error.message))
  }
}

export const approveProperty =
  (propertyId, context = 'Property meets all requirements') =>
  async dispatch => {
    try {
      dispatch(updatePropertyStatusRequest())
      const token = localStorage.getItem('authToken')

      const response = await api.post(
        `/v1/properties/update-status/`,
        {
          propertyId,
          status: 'LIVE',
          context, // Optional context message
        },
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        }
      )

      dispatch(updatePropertyStatusSuccess(response.data.properties))
    } catch (error) {
      dispatch(updatePropertyStatusFail(error.response?.data?.message || error.message))
    }
  }

//decline status
export const declineProperty = (propertyId, statusData) => async dispatch => {
  try {
    dispatch(updatePropertyStatusRequest())
    const token = localStorage.getItem('authToken')
    const response = await api.post(
      `/v1/properties/update-status/`,
      { propertyId, status: statusData.status, reason: statusData.reason },
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }
    )
    dispatch(updatePropertyStatusSuccess(response.properties))
  } catch (error) {
    dispatch(updatePropertyStatusFail(error.response.data.message || error.message))
  }
}

export const deleteProperty = propertyId => {
  const token = localStorage.getItem('authToken')
  return api.delete(`/v1/properties/delete/${propertyId}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  })
}
